export class IdValue {
    id: any;
    value: any;

    constructor(id: any, value: any) {
        this.id = id;
        this.value = value;
    }
}
